import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HeroSection from '@/components/HeroSection';
import StatsBar from '@/components/StatsBar';
import IndustriesServed from '@/components/IndustriesServed';
import PricingCalculator from '@/components/PricingCalculator';
import Testimonials from '@/components/Testimonials';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';
import AdminDashboard from '@/components/AdminDashboard';

function LandingPage({ formVariant = 'default' }) {
  return (
    <div className="min-h-screen bg-[#191E29]">
      <HeroSection formVariant={formVariant} />
      <StatsBar />
      <IndustriesServed />
      <PricingCalculator />
      <Testimonials />
      <CTASection />
      <Footer />

      {/* Sticky mobile CTA */}
      <div className="fixed bottom-0 inset-x-0 z-50 lg:hidden bg-[#191E29]/95 backdrop-blur-lg border-t border-white/10 px-4 py-3 safe-bottom">
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' }); }}
          data-testid="sticky-mobile-cta"
          className="flex items-center justify-center w-full py-3.5 bg-[#07c28e] text-white font-bold text-base rounded-full hover:bg-[#06a879] transition-colors"
        >
          Get Your Free Audit
        </a>
      </div>
    </div>
  );
}

function App() {
  // Path-based variant routing. `/ad` renders the identical landing page
  // but swaps the QuoteForm for the contact-first / exit-intent variant.
  if (typeof window !== 'undefined') {
    const p = window.location.pathname.replace(/\/+$/, '');

    // /arie is served as a static HTML stub by Cloudflare Pages in production.
    // In dev (or if the stub isn't served for any reason) fall back to a JS
    // redirect so the partner UTMs still land clean on /lp.
    if (p === '/arie') {
      const search = window.location.search;
      const extra = search ? '&' + search.slice(1) : '';
      window.location.replace(`/lp/?utm_source=arie&utm_medium=affiliate&utm_campaign=partner_link${extra}`);
      return null;
    }

    // /p/{slug} — dynamic partner routes.
    if (p.startsWith('/p/')) {
      const slug = p.slice(3).replace(/[^a-z0-9_-]/gi, '').toLowerCase();
      if (slug) {
        window.location.replace(`/lp/?utm_source=${encodeURIComponent(slug)}&utm_medium=affiliate&utm_campaign=partner_link`);
        return null;
      }
    }

    // Root-level vanity partner routes (single-segment path that isn't a
    // known route) — fallback dev redirect to /lp with utm_source=slug.
    const knownRoutes = new Set([
      '', '/', '/lp', '/ad', '/arie', '/admin', '/favicon.ico', '/robots.txt', '/manifest.json',
    ]);
    if (
      p &&
      !knownRoutes.has(p) &&
      !p.startsWith('/lp') &&
      !p.startsWith('/p/') &&
      !p.startsWith('/api') &&
      !p.startsWith('/static') &&
      !p.includes('.') &&
      /^\/[a-z0-9][a-z0-9_-]{1,39}$/i.test(p)
    ) {
      const slug = p.slice(1).toLowerCase();
      window.location.replace(`/lp/?utm_source=${encodeURIComponent(slug)}&utm_medium=affiliate&utm_campaign=partner_link`);
      return null;
    }
  }
  return (
    <BrowserRouter>
      <Routes>
        {/* Default (unchanged) landing */}
        <Route path="/lp"        element={<LandingPage />} />
        <Route path="/lp/"       element={<LandingPage />} />
        <Route path="/lp/admin"  element={<AdminDashboard />} />
        {/* /ad — identical landing but contact-first form + exit-intent */}
        <Route path="/ad"        element={<LandingPage formVariant="ad" />} />
        <Route path="/ad/"       element={<LandingPage formVariant="ad" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
